import el from "@cypherpotato/el";
import { api } from "../../api";
import { Badge } from "../../components/badge";
import { Button } from "../../components/button";
import { Card, CardContent } from "../../components/card";
import { CommandBar } from "../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../components/dashboard";
import { Dropdown, DropdownItem } from "../../components/dropdown";
import { Icon } from "../../components/icon";
import { Table, TableActionCell, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "../../components/table";
import { copyToClipboard } from "../../ui/clipboard";
import { formatDateTime } from "../../ui/format";
import { runOperation } from "../../ui/operation";

export default function (ctx) {

    const logs = el.state.create(null);

    function refreshLogs() {
        runOperation("Loading logs...", async () => {
            const result = await api.getJson("/api/v1/information/logs.json");
            logs.value = result.data;
        });
    }

    refreshLogs();

    return Dashboard(
        {
            classList: ["full-size"]
        },
        DashboardTitle(
            "Account Logs",
            "Monitor error logs, warnings, and other notifications about your account."
        ),
        Card(
            CardContent(
                CommandBar(
                    Button(Icon("refresh-line"), "Refresh", {
                        onClick() {
                            refreshLogs();
                        }
                    })
                )
            ),
            CardContent(
                Table(
                    {
                        pagination: {
                            perPage: 30
                        }
                    },
                    TableHeader(
                        TableHeaderCell("Date and time", { width: "15%" }),
                        TableHeaderCell("Level", { width: "10%" }),
                        TableHeaderCell("Message", { width: "75%" }),
                        TableHeaderCell("Actions")
                    ),
                    el.state.listening([logs], () =>
                        TableBody(
                            logs.value?.map(log =>
                                TableRow(
                                    TableCell(formatDateTime(log.createdAt), { title: log.createdAt }),
                                    TableCell(Badge(log.level[0])),
                                    TableCell(el("div.code-like", log.message?.trim())),
                                    TableActionCell(
                                        Dropdown(Icon("more-2-line"),
                                            DropdownItem("Copy to clipboard", Icon("file-copy-line"), {
                                                onClick() {
                                                    copyToClipboard(log.message);
                                                }
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    )
}